import { Badge, Tooltip } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { CallErrorSummary } from './use-call-error-summary';

export function CallErrorBadge({ summary, hint }: { summary: CallErrorSummary | undefined; hint?: string }) {
  if (!summary) return null;

  return (
    <Tooltip
      label={`${summary.count} ${summary.severity} error${summary.count === 1 ? '' : 's'}${hint ? ` — ${hint}` : ''}`}
    >
      <Badge
        variant="light"
        color={summary.severity === 'fatal' ? 'red' : 'yellow'}
        size="sm"
        leftSection={<IconAlertTriangle size={12} />}
      >
        {summary.severity}
      </Badge>
    </Tooltip>
  );
}
